<template>
  <div class="w-full">
    <SmartTitle
      class="mb-4"
      heading="1"
      weight="medium"
    >
      DE-PARA Faturamento
    </SmartTitle>
    <FilterFaturamento />
    <div class="flex justify-end">
      <SmartButton class="mt-4" @click="createDistributorRelation">
        Criar Relação Distribuidores
      </SmartButton>
    </div>
    <section class="mt-4" v-if="!loading">
      <VDataTable
        :headers="headers"
        :items="deParaChipList"
        :must-sort="true"
        hide-actions
        no-data-text="Não há dados a serem exibidos"
        item-key
        class="my-4"
      >
        <template slot="items" slot-scope="props">
          <td>
            <p class="text-opacity-md">{{ props.item.db_from_name }}</p>
          </td>
          <td>
            <p v-for="(db,index) in props.item.db_to" :key="index"
               class="text-opacity-md">
              {{ db.db_to_name }}
            </p>
          </td>
          <td>
            <p class="text-opacity-md">{{ formatDate(props.item.date_start) }} até {{ formatDate(props.item.date_end) }}</p>
          </td>
          <td class="view-icon" width="100">
            <label
              @click="editDistributorRelation(props.item.db_from_id)"
              class="flex flex-row align-center justify-center cursor-pointer"
            >
              <SmartIcon :size="2" name="edit" class="mr-1-2"/>
            </label>
          </td>
        </template>
      </VDataTable>
    </section>
    <div v-else>
      <SmartSkeletonLoading
        :items="6"
        :height="3"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { formatBRDate } from 'utils/date';

export default {
  name: 'DeParaFaturamento',
  components: {
    FilterFaturamento: () => import('./Filter')
  },
  data() {
    return {
      loading: false,
      headers: [
        { text: 'Distribuidor Faturamento de Chip', value: 'dfc', sortable: false },
        { text: 'Distribuidores relacionados', value: 'dfc', sortable: false },
        { text: 'Período', value: 'period', sortable: false },
        { text: 'Editar', value: 'edit', sortable: false }
      ]
    };
  },
  computed: {
    ...mapGetters({
      deParaChipList: 'deParaFaturamento/deParaChipList'
    })
  },
  methods: {
    ...mapActions({
      fetchDePara: 'deParaFaturamento/fetchDePara'
    }),
    formatDate(date) {
      return formatBRDate(date);
    },
    createDistributorRelation() {
      this.$router.push({ name: 'criarRelacaoDistribuidores' });
    },
    editDistributorRelation(id) {
      this.$router.push({ name: 'EditarRelacaoDistribuidores', params: { id } });
    }
  },
  async mounted() {
    this.loading = true;
    await this.fetchDePara();
    this.loading = false;
  }
};
</script>

<style scoped>

</style>
